export * from './industry-form.component';
